<template lang="pug">
  .profile-page__main
    .profile-page__header
      .profile-page__title
        h1.title Настройки аккаунта
    .profile-page__body
      .profile-page-form
        .profile-page-form__section-container
          section.profile-page-form__section.profile-section
            .profile-section__title
              h2.profile-section-title Пароль
            .profile-section__body
              form
                password-change-form
          section.profile-page-form__section.profile-section
            .profile-section__title
              h2.profile-section-title E-mail
            .profile-section__body
              form
                login-change-form
          section.profile-page-form__section.profile-section
            .profile-section__title
              h2.profile-section-title ФИО директора
            .profile-section__body
              form
                .form
                  p.form__description Укажите ФИО директора лагеря. Данное ФИО будет выводиться в договоре.
                  .form__elem
                    .form-elem.form-elem_horizontal(
                    :class="{ 'form-elem_error': fieldsErrors.last_name.value }"
                    )
                      .form-elem__title Фамилия
                      .form-elem__body
                        input.input.input_full(
                        v-model="fields.last_name"
                        @input="resetError('last_name')"
                        )
                  .form__elem
                    .form-elem.form-elem_horizontal(
                    :class="{ 'form-elem_error': fieldsErrors.first_name.value }"
                    )
                      .form-elem__title Имя
                      .form-elem__body
                        input.input.input_full(
                        v-model="fields.first_name"
                        @input="resetError('first_name')"
                        )
                  .form__elem
                    .form-elem.form-elem_horizontal(
                    :class="{ 'form-elem_error': fieldsErrors.fathers_name.value }"
                    )
                      .form-elem__title Отчество
                      .form-elem__body
                        input.input.input_full(
                        v-model="fields.fathers_name"
                        @input="resetError('fathers_name')"
                        )
                  .form__elem.form__elem_button
                    .form-elem
                      .form-elem__body
                        button.button.button_paint-main(
                        @click.prevent="onChangeUserData"
                        ) Изменить ФИО
                      .form-elem__error(
                        v-if="currentErrorMessage.length > 0"
                      ) {{currentErrorMessage}}
</template>
<script>
import {mapState, mapActions} from "vuex";
import PasswordChangeForm from "../../../../../components/password-change-form/PasswordChangeForm";
import LoginChangeForm from "../../../../../components/login-change-form/LoginChangeForm";

export default {
  name: "ManagerSettings",
  components: {
    LoginChangeForm,
    PasswordChangeForm
  },
  data() {
    return {
      fields: {
        last_name: "",
        first_name: "",
        fathers_name: ""
      },
      fieldsErrors: {
        last_name: {
          value: false,
          message: "Введите фамилию"
        },
        first_name: {
          value: false,
          message: "Введите имя"
        },
        fathers_name: {
          value: false,
          message: "Введите отчество"
        }
      },
      currentErrorMessage: ""
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  methods: {
    ...mapActions(["updateUserProfile"]),
    setFields(user) {
      this.fields.last_name = user.last_name;
      this.fields.first_name = user.first_name;
      this.fields.fathers_name = user.fathers_name;
    },
    validation() {
      const fields = [
        "last_name",
        "first_name",
        "fathers_name"
      ];
      const errors = [];

      fields.forEach(item => {
        if (this.fields[item].length === 0) {
          errors.push(item);
          this.fieldsErrors[item].value = true;
        }
      });
      if (errors.length > 0) {
        this.currentErrorMessage = this.fieldsErrors[errors[0]].message;
        return false;
      }
      return true;
    },
    resetError(field) {
      this.fieldsErrors[field].value = false;
      this.currentErrorMessage = "";
    },
    onChangeUserData() {
      if (!this.validation()) {
        return;
      }
      this.updateUserProfile({
        last_name: this.fields.last_name,
        first_name: this.fields.first_name,
        fathers_name: this.fields.fathers_name
      }).then(res => {
        if (res.status === 200) {
          alert("Успешно");
        } else if (res.status === 400) {
          alert("Ошибка");
        } else {
          alert("Ошибка сервера");
        }
      });
    }
  },
  mounted() {
    if (this.userData) {
      this.setFields(this.userData);
    }
  },
  watch: {
    userData(val) {
      if (val) {
        this.setFields(val);
      }
    }
  }
};
</script>
